import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, Col, Row } from "react-bootstrap"
import DropDownField from "../../form/DropDownField"
import { faFileExcel } from "@fortawesome/free-solid-svg-icons"
import { downloadFileFromApi, VehicleSaleStatus } from "../../../config/utils/helper"
import { useForm } from 'react-hook-form';
import { fieldRequired } from "../../../config/validations/rules"
import DateTimePicker from "../../form/DateTimePicker"
import { startOfToday,startOfYesterday} from 'date-fns';
import MultiRadio from "../../../components/form/MultiRadio";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react"
import {getFormatyyyymmdd,addDay,differenceInDay} from "../../../config/utils/dateFunctions"
import HTTP from "../../../config/axios"
import InputTextField from "../../form/InputTextField"
import ReportTable from "./ReportDataTable"
import SimpleToast from '../../common/Toast';
import { encryptLocalStorage } from "../../../config/utils/storage"
import MultiSelectDropdown from "../../form/MultiDropdown"


const ReportCriteria  = () => {

    const { control,setValue,watch, clearErrors, getValues, handleSubmit, reset } = useForm<Record<string, any>>({ defaultValues: { report: '', saleStatus: '',vehicleStatus:'',vehicleAge:JSON.stringify({ value: 1, operator: '=' }), dealership: '' } });
    const [maxDate, setMaxDate] = useState(getFormatyyyymmdd(startOfToday()));
    const [minDate, setMinDate] = useState(getFormatyyyymmdd(startOfYesterday()));
    const [showDateFiter, setShowDateFiler] = useState(false)
    const [showEnquiryDateFilter,setShowEnquiryDateFilter] = useState(false)
    const [vehicleAgeFiler, setVehicleAgeReport] = useState(false)
    const [showSaleStatus, setShowSaleStatus] = useState(false)
    const [showSaleLeadStatus, setShowSaleLeadStatus] = useState(false)
    const [showDealership, setShowDealership] = useState(false)
    const [showSoldFilter, setShowSoldFilter] = useState(false)
    const [reportData, setReportData] = useState([])
    const [reportTypes, setReportTypes] = useState('')
    const [reportFormData, setReportFormData] = useState<Record<string,any>>({})
    const [perPage, setPerPage] = useState<number>(10)
    const [years, setYears] = useState<any>([])
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [toast, setToast] = useState({ open: false, header: '', message: '', variant: '' })
    const [userRoleWeight, setUserRoleWeight] = useState(0);
    const selectedDealership = watch('dealership');
    const [dealershipData, setDealershipData] = useState([])
    const [multiSelectDealershipData, setMultiSelectDealershipData] = useState([])
    const [defaultDealership, setDefaultDealership] = useState('');
    const [selectedMake, setSelectedMake] = useState([]);
    
    const {VEHICLE_SELL_STATUS, VEHICLE_PRE_BOOKED_STATUS, 
            VEHICLE_BOOKED_STATUS, VEHICLE_SOLD_STATUS,
            VEHICLE_BUY_STATUS, VEHICLE_UNPUBLISH_STATUS} = VehicleSaleStatus

    //Vehicle Status
    const vehicleStatusTypeArray = [
        { keyName: '', name: "All" },
        { keyName: 1, name: "Active" },
        { keyName: 0, name: "Archived" },
    ]

    useEffect(()=>{
        console.log("dealershipData", dealershipData)
    }, [dealershipData])

    //Vehicle Sale Status
    const saleStatusTypeArray = [
        { keyName: 'all', name: "All" },
        { keyName: VEHICLE_SELL_STATUS, name: "Sell" },
        { keyName: VEHICLE_PRE_BOOKED_STATUS, name: "Pre-Booked" },
        { keyName: VEHICLE_BOOKED_STATUS, name: "Booked" },
        { keyName: VEHICLE_SOLD_STATUS, name: "Sold" },
        { keyName: VEHICLE_BUY_STATUS, name: "Purchase" },
        { keyName: VEHICLE_UNPUBLISH_STATUS, name: "Unpublished" },
    ]

    //Vehicle Sale Status
    const reportArray = [
        { keyName: 'modelWiseCount', name: "Model Wise Count Report" },
        { keyName: 'publishingAge', name: "Published Age Report" },
        { keyName: 'searchedVehicle', name: "Search Count by Vehicle Model" },
        { keyName: 'enquiryVehicle', name: "Vehicle Based Enquiry" },
        { keyName: 'soldVehicles', name: "Sold Vehicles" },
    ]

    //Vehicle Published Age
    const carAgeOptions = [
        { label: '1 Month', value: JSON.stringify({ value: 1, operator: '<=' })},
        { label: '2 Month', value: JSON.stringify({ value: 2, operator: '<=' })},
        { label: '3 Month', value: JSON.stringify({ value: 3, operator: '<=' })},
        { label: '6 Month', value: JSON.stringify({ value: 6, operator: '<=' })},
        { label: 'More than 6 month', value: JSON.stringify({ value: 7, operator: '>=' })},
    ]

    const SALE_LEADS = [
        { keyName: 10, name: "Sell" },
        { keyName: 20, name: "Buy" },
        { keyName: 30, name: "Finance" },
        { keyName: 40, name: "Premium Park & Sell" },
    ];

    useEffect(() => {
        const user = encryptLocalStorage.getItem('userInfo');
        const accessibleDealership = encryptLocalStorage.getItem('accessibleDealership');
        const dealershipValues = [...new Set(accessibleDealership)];
        
        setUserRoleWeight(user?.roleWeight || 0);
        
        // For users below roleWeight 90, set default dealership
        if (user?.roleWeight < 90 && dealershipValues.length > 0) {
            const defaultValue = String(dealershipValues[0]);
            setDefaultDealership(defaultValue);
            setValue('dealership', defaultValue);
        }
    }, []);

    useEffect(() => {
        try {
            const getAllDealerships = async () => {
                try {
                    const dealershipStatus = 1
                    const params = { status: dealershipStatus };
                    const response = await HTTP.get(`/api/admin/dealership/fetch-all`, { params });
                    const { data: { status, data, msg, error, totalRecords } } = response;
                    const dealershipOptions = data.map((dealership: any) => ({
                        keyName: dealership.id,
                        name: dealership.name
                    }));
                    const multiSelectOptions = data.map((dealership: any) => ({
                        label: dealership.name,
                        value: dealership.id
                    }));
                    setDealershipData(dealershipOptions);
                    setMultiSelectDealershipData(multiSelectOptions);
                    
                    // Auto-populate for branch admins (roleWeight < 90)
                    const user = encryptLocalStorage.getItem('userInfo');
                    const accessibleDealership = encryptLocalStorage.getItem('accessibleDealership');
                    if (user?.roleWeight < 90 && accessibleDealership) {
                        const dealershipIds = Array.isArray(accessibleDealership) ? accessibleDealership : [accessibleDealership];
                        const autoSelectedDealerships = multiSelectOptions.filter((option: any) => 
                            dealershipIds.includes(option.value)
                        );
                        setValue('dealership', autoSelectedDealerships);
                    }
                } catch (error: any) {
                    if (error.response?.status === 401) {
                        setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to access this resource', variant: 'danger' })
                    } else {
                        setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
                    }
                }
            }
            getAllDealerships()
        }
        catch (error) {
            console.log("Error in dealership fetch api")
        }
    }, []);

    useEffect(()=>{
        //Function to fetch the last 5 years
        function getLast5Years() {
            const today = new Date();
            const currentYear = today.getFullYear();
            const year = [];
        
            for (let i = 0; i < 5; i++) {
                const yearData = {
                    keyName:currentYear - i,
                    name: currentYear - i
                }
                year.push(yearData);
            }
        
            setYears(year)
        }
        getLast5Years()
    },[])

    // Define the array of objects
    const months: { keyName: number, name: string }[] = [
        { keyName: 1, name: 'January' },
        { keyName: 2, name: 'February' },
        { keyName: 3, name: 'March' },
        { keyName: 4, name: 'April' },
        { keyName: 5, name: 'May' },
        { keyName: 6, name: 'June' },
        { keyName: 7, name: 'July' },
        { keyName: 8, name: 'August' },
        { keyName: 9, name: 'September' },
        { keyName: 10, name: 'October' },
        { keyName: 11, name: 'November' },
        { keyName: 12, name: 'December' }
    ];




    //Set max date when changing the From datePicker
    useEffect(()=>{
        const slectedFromDate = watch('from')
        
        if(slectedFromDate){
            if(watch('to')){
                setMinDate(getFormatyyyymmdd(addDay(watch('to'),-1) as Date))
            }
            const days = differenceInDay(watch('from'), maxDate) as number;
            if(days < 0){
                setMaxDate(getFormatyyyymmdd(addDay(slectedFromDate,1) as Date))
            }
        }
    },[watch('from')])

  


    //Display the filters according to the selected report Type
    useEffect(()=>{
        //reset() //Reseting the forms when the 
        switch(watch('report')){
            case 'publishingAge':
                setShowEnquiryDateFilter(false)
                setVehicleAgeReport(false);
                setShowDateFiler(true);
                setShowSaleStatus(false);
                setValue('vehicleAge','')
                setShowSaleLeadStatus(false)
                setShowSoldFilter(false)
                setShowDealership(true)
                break;
            case 'searchedVehicle':
                setShowEnquiryDateFilter(false)
                setShowDateFiler(true);
                setVehicleAgeReport(false);
                setShowSaleStatus(false);
                setShowSaleLeadStatus(false)
                setShowSoldFilter(false)
                setShowDealership(false)
                break;

            case 'modelWiseCount':
                setShowEnquiryDateFilter(false)
                setShowDateFiler(true);
                setVehicleAgeReport(false);
                setShowSaleStatus(true);
                setShowSaleLeadStatus(false)
                setShowSoldFilter(false)
                setShowDealership(true)
                break;

            case 'enquiryVehicle':
                setShowEnquiryDateFilter(false)
                setShowDateFiler(true);
                setVehicleAgeReport(false);
                setShowSaleStatus(false);
                setShowSaleLeadStatus(true)
                setShowSoldFilter(false)
                setShowDealership(false)
                break;

            case 'soldVehicles':
                setShowEnquiryDateFilter(false)
                setShowDateFiler(true);
                setVehicleAgeReport(false);
                setShowSaleStatus(false);
                setShowSaleLeadStatus(false);
                setShowSoldFilter(false)
                setShowDealership(true)
                break;

            default :
                setShowDateFiler(false);
                setShowEnquiryDateFilter(false)
                setVehicleAgeReport(false);
                setShowSaleStatus(false);
                setShowSaleLeadStatus(false);
                setShowSoldFilter(false)
                setShowDealership(false)
                break;
        }

    },[watch('report')])

    //Submit 
    const onSubmit = async (formData: any) => {
        try {
            // Transform dealership array to extract only IDs
            const transformedData = { ...formData };
            if (formData.dealership && Array.isArray(formData.dealership)) {
                transformedData.dealership = formData.dealership.map((item: any) => item.value);
            }
            
            setReportFormData(transformedData);
            setCurrentPage(1);  
        }
        catch (error: any) {
            setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
        }
    };

    useEffect(()=>{

        //Api to fetch the report Data
        const getReportData = async()=>{
            try{
                console.log("hereee")
                const params = reportFormData
                params['currentPage'] = currentPage
                params['perPage'] = perPage
                const accessibleOutlets = encryptLocalStorage.getItem('accessibleOutlets');
                
                if (userRoleWeight >= 90 && params.dealership) {
                    params['dealershipId'] = Array.isArray(params.dealership) ? params.dealership : [params.dealership];
                } else {
                    params['accessibleOutlets'] = Array.isArray(accessibleOutlets) ? accessibleOutlets : (accessibleOutlets ? [accessibleOutlets] : []);
                }

                const response:any = await HTTP.get(`/api/admin/vehicle/report/`, { params,responseType:params.reportType != 'report'? 'blob':'json' });
                

                if(params.reportType != 'report'){
                    const filename = response.headers['content-disposition'].split('filename="')[1].split('"')[0];
                    downloadFileFromApi(response.data, filename)
                } else{
                    const { data: { status, data } } = response
                    if(status){
                    
                        setReportData(data)
                        setReportTypes(reportFormData.report)
    
                    } else{
                        setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })  
                    }
                }

            } catch(err){
                console.log(err)
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        }

        if(Object.keys(reportFormData).length){
            getReportData()
        }
        
    },[currentPage,perPage,reportFormData])



    //handleClick
    const handleClickReport = (reportType:string)=>{
        setValue('reportType',reportType)
        handleSubmit(onSubmit)()
    }

    //Handle PerPage
    //Handling the page change
    const handlePageChange = (page: any) => {
        setCurrentPage(page)
    }

    //handling the no.of rows changing
    const handlePerRowsChange = async (newPerPage: number, page: number) => {
        setPerPage(newPerPage)
    };

    return (
        <>
            <Card>
                <Card.Header className="bg-primary">Filter Criteria</Card.Header>
                <Card.Body>
                <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className='mb-1'>
                
                    <Col md={4} className="mb-2">
                        <DropDownField label="Report" name="report" options={reportArray} control={control} rule={{ required: fieldRequired }} clearErrors={clearErrors} placeholder="Choose a Report" isValueKeyname={true}/>    
                    </Col>
                    {showSaleStatus && <Col md={4}>
                        <DropDownField label="Vehicle Status" name="vehicleStatus" options={vehicleStatusTypeArray}
                            control={control} placeholder="Vehicle Status" isValueKeyname={true} />
                    </Col>}
                    {showSaleStatus &&
                        <Col md={4}>
                            <DropDownField label="Sale Status" name="saleStatus" options={saleStatusTypeArray} control={control}   clearErrors={clearErrors} placeholder="Choose a status" rule={{ required: fieldRequired }}  isValueKeyname={true}/>
                        </Col>
                    }
                            {showSaleLeadStatus &&
                                <Col md={4}>
                                    <DropDownField label="Sale Lead Status" name="saleLeadStatus" options={SALE_LEADS} control={control} clearErrors={clearErrors} placeholder="Choose a status" rule={{ required: fieldRequired }} isValueKeyname={true} />
                                </Col>
                            }
                            {showDealership &&
                                <Col md={4} className="">
                                    <MultiSelectDropdown
                                        label="Dealership"
                                        name="dealership"
                                        options={multiSelectDealershipData}
                                        control={control}
                                        placeholder="Choose Dealership"
                                        selectedValues={watch('dealership') || []}
                                        setValues={(values:any) => setValue('dealership', values)}
                                        classList="text-dark"
                                        isDisabled={userRoleWeight < 90}
                                    />
                                </Col>
                            }
                    {vehicleAgeFiler &&
                        
                        <Col md={12} className="d-flex p-3">
                        <label className="text-dark fw-semibold form-label fs-6  ">Choose Vehicle Published Age <span className="text-danger fw-bold">*</span></label> 
                        
                        <MultiRadio name="vehicleAge" control={control} label ='Vehicle Published Age'   rule={{ required: fieldRequired }}
                            options={carAgeOptions} classList="ms-2"   selectedValue={watch('vehicleAge')} />
                        </Col>
                    }

                    {showDateFiter &&
                        <>
                            <Col md={4}>
                                <div className="mb-3">
                                    <DateTimePicker label="From" name="from" type="date" control={control} max={minDate} rule={{ required: fieldRequired }} clearErrors={clearErrors} placeholder="From" />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-3">
                                    <DateTimePicker label="To" name="to" type="date" control={control} min={maxDate} rule={{ required: fieldRequired }} clearErrors={clearErrors} placeholder="To" />
                                </div>
                            </Col>
                        </>
                        
                    }
                            {showEnquiryDateFilter &&
                                <>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <DateTimePicker label="Enquiry Date" name="enquiryDate" type="date" control={control} max={maxDate} rule={{ required: fieldRequired }} clearErrors={clearErrors} placeholder="Enquiry Date" />
                                        </div>
                                    </Col>
                                </>

                            }

                    {showSoldFilter &&
                        <>
                            <Col md={4}>
                                <DropDownField label="Year" name="year" options={years} control={control} clearErrors={clearErrors} placeholder="Choose a year" rule={{ required: fieldRequired }} isValueKeyname={true} />
                            </Col>
                            <Col md={4}>
                                <DropDownField label="Month" name="month" options={months} control={control} clearErrors={clearErrors} placeholder="Choose a month" rule={{ required: fieldRequired }} isValueKeyname={true} />
                            </Col>
                        </>
                        
                    }

                    <InputTextField name="reportType" label=""
                            placeholder="" type="hidden" clearErrors={clearErrors}
                            control={control} rule={{ required: fieldRequired }} />
                    
                </Row>
                <Row>
                    <div className="d-flex " >
                        <div className="ms-auto p-2">
                            <Button className="p-2 "  type="button" onClick={()=>handleClickReport('report')} variant="success" value ="report"> Generate Report </Button> 
                        </div>
                        <div className=" p-2">
                            <Button className="p-2" type="button" onClick={()=>handleClickReport('csv')} value ="csv" variant="success"> <FontAwesomeIcon icon={faFileExcel} size='lg' /> </Button>
                        </div>
                    </div>

                </Row>
                </Form>
                </Card.Body>
            </Card>
            
            <ReportTable reportData = {reportData} 
                reportTypes = {reportTypes}
                handlePageChange = {handlePageChange}
                handlePerRowsChange = {handlePerRowsChange}
            />

            <SimpleToast show={toast.open} header={toast.header}
                message={toast.message} variant={toast.variant}
                onClose={() => setToast({ ...toast, open: false })} />
        </>
    )
}

export default ReportCriteria